import axios from "axios";
import { API_URL } from "../index";
import { USER_INFOS_TTL_MS, userInfosCache, invalidateUserInfosCache } from "../servisOrtak";

// FE-84: Services.js'ten taşındı (33 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
if (process.env.NODE_ENV !== "test" && !process.env.REACT_APP_API_GUEST_KEY) {
  // eslint-disable-next-line no-console
  console.error("REACT_APP_API_GUEST_KEY tanımlı değil (.env): misafir token alınamaz; giriş/kayıt çalışmaz.");
}

const servisKullanici = {
  // 26.10.2026 (güvenlik manifesti FE-P1-1): misafir anahtarı kaynak kodda DURMAZ; build ortam değişkeninden gelir
  // (.env — git'e girmez; örnek .env.example). Tanımsızsa build'de uyarı verilir, istek API'de reddedilir.
  GetToken() {
    return axios({
      method: "post",
      url: `${API_URL}get-token`,
      data: {
        key: process.env.REACT_APP_API_GUEST_KEY || "",
        secret: process.env.REACT_APP_API_GUEST_SECRET || ""
      },
    });
  },
  SendOTP(token, phone, otp) {
    return axios({
      method: "post",
      url: `${API_URL}flow/send-otp`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        phone: phone,
        otp: otp
      },
    });
  },
  // consents: { gdprConfirmation, termsOfUseConfirmation } — kayıt ekranındaki zorunlu
  // onaylar backend'de kalıcı olarak işlenir (users::create → userconsents.upsertForUser).
  UserRegister(token, name, lastname, password, email, phone, countryCode, consents = {}, type = "merchant", applicationNote = "") {
    // type portala göre belirlenir: müşteri domaininde "customer", diğerlerinde "merchant".
    // currentStatus'u sunucu belirler (bilgi amaçlı gönderilir; customer→0 aktif, merchant→3 onay).
    // applicationNote yalnız merchant başvurusunda gönderilir (BE whitelist'te; müşteri boş geçer).
    return axios({
      method: "post",
      url: `${API_URL}flow/user-register`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        name: name,
        lastname: lastname,
        password: password,
        email: email,
        phone: phone,
        type: type,
        countryCode: countryCode,
        currentStatus: type === "customer" ? 5 : 3, // müşteri → "İletişime Geçilecek", merchant → "Onay Bekliyor" (BE de zorlar)
        gdprConfirmation: Boolean(consents?.gdprConfirmation),
        termsOfUseConfirmation: Boolean(consents?.termsOfUseConfirmation),
        applicationNote: applicationNote || "",
      },
    });
  },
  // portal (güvenlik manifesti FE-P2-4): "customer" (my.) | "admin" (panel.) | "partner" (partner.). BE, portal ile
  // kullanıcı tipi uyuşmazsa token vermeyecek; alan şimdiden gönderilir. localhost'ta (portal yok) gönderilmez.
  UserLogin(token, email, password, portal = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/user-login`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        email: email,
        password: password,
        ...(portal ? { portal } : {}),
      },
    });
  },
  // Yetkili müşteri özeti: hangi müşteri hangi oda için KİM tarafından yetkilendirildi.
  // Müşteriler sayfasında (a) yetkilileri listeye dahil etmek, (b) statü yanındaki "i"
  // ikonunu doldurmak için kullanılır. Admin tümünü, merchant kendi firmasını görür.
  GetAuthorizedCustomerSummary(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-authorized-customer-summary`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: {},
    });
  },
  GetUserInfo(token, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-users`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID: userID
      }
    });
  },
  GetAllUsers(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-users`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
  // Yönetici kullanıcı yönetimi (Yetkilendirme > Yöneticiler). Yetki BE'de: user-permissions
  // sayfasının user-add / user-offboard yetenekleri + rol hiyerarşisi.
  AdminUserCreate(token, { name, lastname, email, phone, countryCode, role, password }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/admin-user-create`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { name, lastname, email, phone, countryCode, role, password },
    });
  },
  // İşten ayrıldı: status=9 (giriş yapamaz, oturumları kapanır). Müşteri temsilcisiyse karar
  // zorunlu: newCustomerSupport (yeni temsilci) ya da keepCustomerSupport (mevcut temsilci kalsın).
  AdminUserOffboard(token, userID, newCustomerSupport = "", { keepCustomerSupport = false } = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/admin-user-offboard`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { userID, newCustomerSupport, keepCustomerSupport: keepCustomerSupport ? 1 : 0 },
    });
  },
  // Yöneticinin müşteri temsilcisi olduğu müşteri sayısı → { userID, customerCount }.
  AdminUserAssignedCustomers(token, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/admin-user-assigned-customers`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { userID },
    });
  },
  // frontAuth: bir admin kullanıcının alt-rolünü ve sayfa/aksiyon yetkilerini günceller.
  // frontAuth canonical format: { [pageKey]: string[] }  (örn. { "users": ["view", "edit"] })
  UpdateUser(token, { userID, role, frontAuth }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        role,
        frontAuth,
      }
    });
  },

  CreateUserManually(token, name, lastname, email, phone, countryCode, type, currentStatus, channel, customerSupport, secondaryContacts, gender, referenceFullName, affiliateCompany, serviceSubject = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-user-manually`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        name,
        lastname,
        email,
        phone,
        countryCode,
        type,
        currentStatus,
        channel,
        customerSupport,
        secondaryContacts,
        gender,
        referenceFullName,
        affiliateCompany,
        serviceSubject
      }
    });
  },

  UpdateUserProfile(token, userID, name, lastname, email, phone, countryCode, type, currentStatus, channel, customerSupport, secondaryContacts, gender, referenceFullName, affiliateCompany, serviceSubject = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user-profile`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        name,
        lastname,
        email,
        phone,
        countryCode,
        type,
        currentStatus,
        channel,
        customerSupport,
        secondaryContacts,
        gender,
        referenceFullName,
        affiliateCompany,
        serviceSubject
      }
    });
  },
  UpdateProfile(token, userID, name, lastname, email, phone, countryCode, secondaryPhone, nationality, billing) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user-profile`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        name,
        lastname,
        email,
        phone,
        countryCode,
        secondaryPhone,
        nationality,
        billing
      }
    });
  },

  // Kullanıcının kendi şifresini değiştirmesi: mevcut şifre backend'de doğrulanır.
  UpdateUserPassword(token, userID, password, currentPassword = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user-profile`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        password,
        ...(currentPassword ? { currentPassword } : {})
      }
    });
  },

  // Müşteri Profili > Geçici Şifre: müşterinin şifresini geçici bir şifreyle değiştirip
  // e-posta ile gönderir. Yalnız admin (backend de tip kapısıyla doğrular).
  // Düz parola yanıtta DÖNMEZ; yalnız gönderim bilgisi döner.
  UserSendTemporaryPassword(token, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/user-send-temporary-password`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID
      }
    });
  },

  ForgotPassword(token, email) {
    return axios({
      method: "post",
      url: `${API_URL}flow/user-forgot-password`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        email
      }
    });
  },

  ConfirmOTP(token, email, otp) {
    return axios({
      method: "post",
      url: `${API_URL}flow/user-confirm-otp`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        email,
        otp
      }
    });
  },

  UploadAvatar(token, file, name, extension) {
    return axios({
      method: "post",
      url: `${API_URL}flow/user-upload-avatar`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        file,
        name,
        extension
      }
    });
  },
  UpdateUserCustomerSupport(token, userID, customerSupport) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user-profile`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        customerSupport
      }
    });
  },

  GetCustomerNotes(token, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-customer-additional-notes`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID
      }
    });
  },

  DeleteCustomerNote(token, userID, noteID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-customer-additional-note`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        noteID
      }
    });
  },

  GetDocumentsList(token, { signal } = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-documents-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      signal
    });
  },

  // Kullanıcı onayları (KVKK, tanıtım e-postası vb.) — imzalanan sözleşmelerden ayrı,
  // checkbox ile onaylanan dinamik liste. payload.userID yalnızca admin/customer_support
  // için (başka müşteri adına talep oluştururken ön-doldurma).
  GetUserConsents(token, payload = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-user-consents`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload && typeof payload === "object" ? payload : {}
    });
  },

  // Onay metninin OKUNDUĞUNU (bilgilendirme) işaretler — onay/kabul DEĞİLDİR.
  MarkUserConsentInformed(token, consentType) {
    return axios({
      method: "post",
      url: `${API_URL}flow/mark-user-consent-informed`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { consentType }
    });
  },

  SetUserConsent(token, consentType, accepted) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-user-consent`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { consentType, accepted: Boolean(accepted) }
    });
  },
  // ---- İKİNCİL İRTİBAT KİŞİLERİ (müşterinin kendi listesi) ----
  // Admin'in müşteri detayında düzenlediği listeyle AYNI kaynak (user_secondary_contacts).
  // BE listeyi BÜTÜNÜYLE değiştirir → her zaman TAM liste gönderilir. Okuma: GetUserInfos → secondaryContacts.
  // contacts: [{ secondaryName, secondaryLastname, secondaryEmail, secondaryPhone (E.164),
  //              secondaryRelation, secondaryTckn, secondaryAddress }]
  SaveOwnSecondaryContacts(token, contacts) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user-profile`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { secondaryContacts: Array.isArray(contacts) ? contacts : [] },
    });
  },
  // İkincil irtibat ONAY DAVETİNİ yeniden gönderir (MAİL ATAR). Yalnız kişiyi ekleyen müşteri ya da
  // admin çağırabilir. Reddetmiş kişi tekrar sorulur (wasRejected). BE sınırı: 1 saat bekleme, kişi başı 5.
  ResendSecondaryContactInvitation(token, contactID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/resend-secondary-contact-invitation`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { contactID: String(contactID || "") },
    });
  },
  GetUserDocuments(token, customerID = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-user-documents`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: customerID ? { customerID } : {}
    });
  },

  // docType: tax_plate | signature_circular | id_front | id_back; file: {file(base64), name, extension}
  SetUserDocument(token, docType, file, customerID = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-user-document`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { docType, file, ...(customerID ? { customerID } : {}) }
    });
  },

  GetUserType(token, { signal }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-user-type`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      signal
    });
  },

  DeleteOwnAccount(token, email, password) {
    return axios({
      method: "post",
      url: `${API_URL}flow/delete-own-account`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { email, password },
    });
  },

  GetUserInfos(token) {
    const c = userInfosCache;
    if (c.promise && c.token === token && (c.at === 0 || Date.now() - c.at < USER_INFOS_TTL_MS)) return c.promise;
    const promise = axios({
      method: "post",
      url: `${API_URL}flow/get-user-infos`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    }).then(
      (res) => { if (userInfosCache.promise === promise) userInfosCache.at = Date.now(); return res; },
      (err) => { if (userInfosCache.promise === promise) invalidateUserInfosCache(); throw err; },
    );
    Object.assign(userInfosCache, { token, at: 0, promise }); /* at=0: istek uçuşta */
    return promise;
  },
};

export default servisKullanici;
